import { faFacebook, faInstagram, faLinkedinIn, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";

import { faArrowRight, faCode, faMobileAlt, faPalette, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InViewPort from "../../components/utilities/in-viewport";
import { homeProcesses } from "../../_helpers/mock-data";
import { GenLeft } from "../../components/utilities/service-framer";
import { Footer } from "../../components/footer/footer";
import { Header } from "../../components/header/header";
import { useState } from "react";
import { HomeActionDialog } from "../../components/action-dialogs/home-dialog";
import { AnimatedLoader } from "../../components/utilities/loader-anim";

export const HomePage = () => {

    const navigateTo = useNavigate();

    const [showDialog, setShowDialog] = useState(false);

    return (
        <div className="rand-page">
            <Header pageTitle={"Welcome To RandomWalkTech"} />
                {/* <AnimatedLoader /> */}
                <HomeActionDialog
                    toggleClose={() => setShowDialog((st) => !st)}
                    visible={showDialog}
                />
            

            <div className="home-page-cols">
                <div className="welcome-scr">
                    <div className="glassy-effect w-cont">
                        <div className="gradient-text wlc">Random Walk Tech</div>
                        <div className="intro-text">
                            Pioneering the future with <span className="ai-emph">AI-assisted</span> technology solutions. We transform ideas into digital reality through innovation and intelligence.
                        </div>

                        <div className="descr-btns">
                            <button
                                className="descr-btn st-btn bt-bl-bg"
                                style={{ backgroundImage: `linear-gradient(to bottom right, #140c38ff, #126872ff` }}
                                onClick={() => setShowDialog((st) => (!st))}
                            >
                                <span className="btn-cap">Get Started</span>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                            <button
                                className="descr-btn st-btn bt-blk-bg"
                                onClick={() => navigateTo("/personnel")}
                            >
                                <span className="btn-cap">Meet Our Team</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="serv-title">
                    <span>Our</span>
                    <span className="gradient-text"> AI-Powered </span>
                    <span>Services</span>
                </div>
                
                <div className="services-box" >
                    <InViewPort>
                        <div className="service glassy-effect"
                            onClick={() => navigateTo("/services/web-development")}
                        >
                            <div className="ico bl-bg">
                                <FontAwesomeIcon icon={faCode} color="#fff" />
                            </div>
                            <div className="service-cap">Web Development</div>
                            <div className="service-text">AI-powered web solutions that scale with your business</div>
                            <div className="learn-txt">
                                <span>Learn More</span>
                                <FontAwesomeIcon
                                    icon={faArrowRight}
                                />
                            </div>
                        </div>
                    </InViewPort>
                    <InViewPort>
                        <div className="service glassy-effect"
                            onClick={() => navigateTo("/services/mobile-development")}
                        >
                            <div className="ico pnk-bg">
                                <FontAwesomeIcon icon={faMobileAlt} color="#fff" />
                            </div>
                            <div className="service-cap">Mobile Development</div>
                            <div className="service-text">Cross-platform mobile apps with intelligent features</div>
                            <div className="learn-txt">
                                <span>Learn More</span>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </div>
                        </div>
                    </InViewPort>
                    <InViewPort>
                        <div className="service glassy-effect"
                            onClick={() => navigateTo("/services/graphics-design")}
                        >
                            <div className="ico gr-bg">
                                <FontAwesomeIcon icon={faPalette} color="#fff" />
                            </div>
                            <div className="service-cap">Graphics Design</div>
                            <div className="service-text">AI-enhanced visual design that captivates audiences</div>
                            <div className="learn-txt">
                                <span>Learn More</span>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </div>
                        </div>
                    </InViewPort>
                    <InViewPort>
                        <div className="service glassy-effect"
                            onClick={() => navigateTo("/services/cyber-security")}
                        >
                            <div className="ico or-bg">
                                <FontAwesomeIcon icon={faShieldAlt} color="#fff" />
                            </div>
                            <div className="service-cap">Cyber Security</div>
                            <div className="service-text">AI-driven security solutions for digital protection</div>
                            <div className="learn-txt">
                                <span>Learn More</span>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </div>
                        </div>
                    </InViewPort>
                </div>
                <InViewPort>
                    <div className="page-sub-cap">
                        <span className="norm-text">Why Choose</span>
                        <span className="gradient-text">AI-Assisted</span>
                        <span className="norm-text">Solutions</span>
                    </div>
                </InViewPort>
                <InViewPort>
                    <div className="services-box">
                        {homeProcesses.map((process, indx) => (
                            <GenLeft key={indx}>
                                <div className="process-unit">
                                    <div className="bl-bg gen-proc-circle">
                                        <FontAwesomeIcon icon={process.icon} />
                                    </div>
                                    <div className="process-caption">{process.caption}</div>
                                    <div className="process-descr">{process.descr}</div>
                                </div>
                            </GenLeft>
                        ))}
                    </div>
                </InViewPort>
                <InViewPort>
                    <GenLeft>
                        <div className="offer-bx glassy-effect">
                            <div className="q-cap">
                                <span className="norm-text of-cap">Ready to </span>
                                <span className="gradient-text of-cap">Transform</span>
                                <span className="norm-text of-cap">Your Business?</span>
                            </div>
                            <div className="descr">
                                Let's discuss how our AI-assisted solutions can accelerate your digital transformation
                            </div>
                            <div className="bttn">
                                <button className="of-btn bl-btn">
                                    <span className="of-btn-txt">Start Your Project</span>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>

                        </div>
                    </GenLeft>
                </InViewPort>
            </div>
            <Footer />
        </div>
    );
}